module.exports = __webpack_public_path__ + "img/b18-3.750ecdc8.jpg";